import React, { forwardRef } from "react";
import { MDBDataTableV5 } from "mdbreact";
import moment from "moment";

const DataTablesApprovers = forwardRef((props, ref) => {
  let data = props.data;
  let finalData = [];

  if (data) {
    for (var index = 0; index < data.length; index++) {
      let rowItem = {};
      rowItem["id"] = index + 1;
      rowItem["image"] = <img className="rounded-circle" height={40} width={40} alt="75x75" src={data[index]?.profile_pic_url} />;
      rowItem["name"] = data[index].approver_name;
      rowItem["title"] = data[index].module_name;
      rowItem["createdAt"] = moment(data[index].createdAt).format('DD/MM/YYYY');
      // rowItem["status"] = <span className="bg_new_status">{data[index].status}</span>;
      // rowItem["editButton"] = <Link className="btn custom-btn-outline-info" to={`/project/${data[index].id}`}><i className="fa fa-edit"></i></Link>;

      finalData.push(rowItem);
    }
    //console.log("final data", finalData);
  }

  //const [datatable, setDatatable] = React.useState({
  const datatable = {
    columns: [
      {
        label: 'Module Name',
        field: 'title',
        sort: 'asc',
        width: 150
      },
      {
        label: 'Profile',
        field: 'image',
        sort: 'asc',
        width: 150
      },
      {
        label: 'Name',
        field: 'name',
        sort: 'asc',
        width: 150
      },
      {
        label: 'Create at',
        field: 'createdAt',
        sort: 'disabled',
        width: 150
      },
      // {
      //   label: 'Status',
      //   field: 'status',
      //   width: 150,
      //   sort: 'disabled'
      // },
      // {
      //   label: '',
      //   field: 'editButton',
      //   width: 150,
      //   sort: 'disabled'
      // } 
    ],
    rows: finalData
  };
  return (
    <MDBDataTableV5
      id="mdbDtTable"
      hover
      bordered
      small
      sortable={false}
      striped
      entriesOptions={[5, 10, 20, 25]}
      entries={5}
      pagesAmount={4}
      data={datatable}
      searchBottom={false}
    />

  );
});

export default DataTablesApprovers;